export default {
  avatar: {
    title: "Avatar ändern",
  },
  bindRole: {
    allServers: "Alle Server",
    bindFailed: "Charakterverknüpfung fehlgeschlagen",
    bindSuccess: "Charakter verknüpft",
    getRoleListFailed: "Abrufen der Charakterliste fehlgeschlagen.",
    getServerListFailed: "Abrufen der Serverliste fehlgeschlagen.",
    modifyTitle: "Verknüpften Charakter ändern",
    noRole: "Kein Charakter verfügbar",
    recentServers: "Dein Server",
    role: "Charaktername:",
    rolePlaceholder: "Charakter auswählen",
    server: "Server:",
    serverPlaceholder: "Server auswählen",
    title: "Charakter verknüpfen",
  },
  commentModal: {
    placeholder: "Kommentar schreiben ...",
    replyTo: "Antworten an {username}",
    title: "Kommentieren",
  },
  common: {
    cancel: "Abbrechen",
    confirm: "OK",
    landscapeTip:
      "Bitte drehen Sie Ihr Telefon in den Hochformat-Modus für eine bessere Erfahrung",
    loadMore: "Nach oben ziehen, um mehr zu laden.",
    loading: "Wird geladen ...",
    loadingMore: "Mehr laden ...",
    noMore: "Keine weiteren Daten",
    refreshFailed: "Aktualisierung fehlgeschlagen",
    refreshSuccess: "Aktualisiert",
    submit: "Absenden",
    all: "Alle",
    language: "Sprache",
  },
  error: {
    50002: "Ungültiger oder abgelaufener Token.",
    50006: "Spitzname wird bereits von einem anderen Benutzer verwendet.",
    50007:
      "Sie können Ihren Spitznamen nur einmal pro Monat ändern. Sie haben ihn diesen Monat bereits geändert",
    50008: "Unzureichende Punkte",
    50301: "Du hast keine Berechtigung zu posten.",
    50302: "Beitragsgrenze erreicht",
    50303: "Die Länge des Inhalts entspricht nicht den Anforderungen",
    50304:
      "Inhalt enthält sensible Wörter, bitte ändere und versuche es erneut.",
    50308: "Du hast keine Berechtigung, diesen Beitrag anzusehen.",
    50309: "Beitrag wurde gelöscht oder verschoben.",
    50351: "Thema ist geschlossen, Antworten nicht möglich.",
    50353: "Du hast keine Berechtigung zu antworten.",
    50354: "Antworten sind in diesem Bereich nicht erlaubt.",
    50355: "Du postest zu häufig, bitte versuche es später erneut.",
    50356: "Stündliches Beitragslimit erreicht.",
    50361: "Kommentar nicht gefunden.",
    50500: "Du kannst die Suchfunktion noch nicht nutzen.",
    50501: "Suchfunktion deaktiviert",
    50502: "Inhalt enthält sensible Wörter, bitte ändere und versuche es erneut.",
    50505: "Suche zu häufig, bitte versuchen Sie es später erneut",
    50703: "Bildüberprüfung fehlgeschlagen",
    50704: "Bildinhalt entspricht nicht den Standards.",
    50214: "Teilen fehlgeschlagen: Sie sind keiner @:shareModal.alliance beigetreten.",
    common: "Vorgang fehlgeschlagen, bitte versuche es später erneut.",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "Angemeldet",
    loginInSuccess: "Anmeldung erfolgreich",
    pleaseLogin: "Bitte logge dich zuerst ein.",
    loginNow: "Anmelden",
    pullToRefresh: "Nach unten ziehen zum Aktualisieren",
    releaseToRefresh: "Loslassen zum Aktualisieren",
    signFailed: "Anmeldung fehlgeschlagen",
    signIn: "Anmelden",
    signInFailedTip:
      "Anmeldung fehlgeschlagen, bitte versuche es später erneut.",
    signSuccess: "Anmeldung erfolgreich",
    goToShop: "Zum Punktezentrum gehen",
    sortByLastPost: "Neueste Kommentare",
    sortByTime: "Neueste",
    tags: {
      activity: "Event",
      chats: "Diskutieren",
      guide: "Anleitung",
      recommend: "Empfehlen",
      news: "Nachrichten",
    },
    unboundRole: "Charakter nicht verknüpft.",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "Wartung",
    message:
      "Entschuldigung, das Spielforum wird derzeit gewartet. Bitte versuchen Sie es später erneut.",
  },
  mentionModal: {
    searchPlaceholder: "Nach Benutzer suchen",
    title: "Benutzer auswählen",
  },
  nicknameModify: {
    alreadyRenamed:
      "Spitzname kann nur einmal pro Monat geändert werden, und du hast ihn diesen Monat bereits geändert.",
    changedNickname: "Spitznamen ändern",
    cost: "Kosten",
    date: "Datum",
    getMore: "Erhalten",
    nicknameTooShort: "Der Spitzname muss mindestens 3 Zeichen lang sein.",
    coinNotEnough: "Unzureichende Punkte",
    placeholder: "Bitte Spitznamen eingeben",
    recordTitle: "Bearbeitungsverlauf",
    sameNickname:
      "Der neue Spitzname darf nicht derselbe sein wie der aktuelle.",
    success: "Änderung gespeichert",
    viewRecord: "Bearbeitungsverlauf",
  },
  notice: {
    empty: "Noch keine Nachrichten",
    likeComment: "{username} hat deinen Kommentar geliked",
    likePost: "{username} hat deinen Beitrag geliked",
    mentionComment: "{username} hat deinen Kommentar erwähnt",
    mentionPost: "{username} hat deinen Beitrag erwähnt",
    replyComment: "{username} hat auf deinen Kommentar geantwortet",
    replyPost: "{username} hat auf deinen Beitrag geantwortet",
    system: "Systembenachrichtigung",
    tabs: {
      like: "Gefällt mir",
      mention: "Hat mich erwähnt",
      notification: "Benachrichtigung",
      reply: "Hat mir geantwortet",
    },
    title: "Nachrichtenbenachrichtigung",
  },
  operateModal: {
    confirmDelete: "Bist du sicher, dass du diesen Beitrag löschen möchtest?",
    copyFailed: "Kopieren fehlgeschlagen",
    copyLink: "Link kopieren",
    copySuccess: "Kopiert",
    delete: "Löschen",
    shareToGame: "Im Spiel teilen",
    deleteFailed: "Löschen fehlgeschlagen",
    deleteSuccess: "Löschen abgeschlossen",
    title: "Aktion",
  },
  shareModal: {
    selectChannelTitle: "Bitte wähle den Kanal zum Teilen",
    channelLabel: "Kanal",
    channelPlaceholder: "Kanal auswählen",
    alliance: "Allianz",
    shareSuccess: "Erfolgreich geteilt",
    continueBrowse: "Weiter stöbern",
    goToGame: "Im Spiel ansehen",
    noThreadTip: "Bitte zuerst einen Beitrag öffnen",
  },
  post: {
    create: {
      contentEmpty: "Inhalt darf nicht leer sein.",
      contentPlaceholder: "Sag etwas ...",
      failed: "Beitrag fehlgeschlagen",
      fileTooLarge: "Dateigröße überschreitet Limit (max {maxSize})",
      image: "Bild",
      imageSizeLimit: "Bildgröße muss unter 5 MB sein.",
      imageUploadFailed: "Bild konnte nicht hochgeladen werden.",
      imageUploadSuccess: "Bild hochgeladen",
      imageUploading: "Bild wird hochgeladen, bitte warten.",
      invalidFileType: "Nicht unterstützter Dateityp.",
      maxCharsReached: "Maximale Zeichenanzahl erreicht ({max} Zeichen)",
      mention: "{'@'}",
      selectBoard: "Abschnitt auswählen",
      topicLabel: "Thema",
      submit: "Beitrag",
      submitting: "Wird gepostet ...",
      success: "Gepostet",
      title: "Beitrag",
      titleEmpty: "Titel darf nicht leer sein.",
      titlePlaceholder: "Titel eingeben",
      video: "Video",
      videoSizeLimit: "Videogröße muss unter 50 MB sein.",
      videoUploadFailed: "Video konnte nicht hochgeladen werden.",
      videoUploadSuccess: "Video hochgeladen",
      videoUploading: "Video wird hochgeladen, bitte warten ...",
    },
    title: "Beitrag",
  },
  postDetail: {
    allComments: "Alle {num} Antworten",
    allReplies: "Allen antworten",
    author: "Autor",
    cancelFavorite: "Aus Favoriten entfernt",
    commentTooShort: "Kommentar muss mindestens 5 Zeichen lang sein.",
    translate: "Übersetzen",
    translating: "Wird übersetzt...",
    translateSuccess: "Erfolgreich übersetzt",
    translateFailed: "Übersetzung fehlgeschlagen",
    translatedTo: "Übersetzt in",
    earliest: "Früheste Antwort",
    favoriteSuccess: "Zu Favoriten hinzugefügt",
    floor: "Floor",
    latest: "Neueste Antwort",
    loadFailed: "Laden fehlgeschlagen",
    noContent: "Kein Inhalt",
    onlyAuthor: "Nur Autor",
    reply: "Antworten",
    replyTo: "Antworten",
    sendFailed: "Senden fehlgeschlagen",
    sendSuccess: "Gesendet",
    sending: "Wird gesendet ...",
    viewOriginalPost: "Originaler Beitrag",
    writeSomething: "Sagt etwas ...",
  },
  profile: {
    addLikeSuccess: "Gefällt",
    cancelLikeSuccess: "Nicht gefallen",
    communityId: "Community-ID",
    editNickname: "Spitznamen ändern",
    followSuccess: "Folgt",
    followed: "Folgt",
    followers: "Follower",
    follow: "Folgen",
    likes: "Gefällt mir",
    noFavorites: "Keine Favoriten",
    noPosts: "Keine Updates",
    shopLabel: "Punkte-Shop",
    tabs: {
      favorites: "Meine Favoriten",
      posts: "Meine Updates",
    },
    title: "Profil",
    unfollowSuccess: "Nicht gefolgt",
  },
  search: {
    btn: "Suchen",
    empty: "Keine verwandten Inhalte",
    filter: {
      dateline: "Neueste",
      title: "Sortieren",
      views: "Beliebt",
    },
    historyTitle: "Suchverlauf",
    hotTitle: "Trends",
    relatedPosts: "Verwandte Beiträge",
    tabs: {
      post: "Beitrag",
      user: "Benutzer",
    },
  },
  setting: {
    about: "Über uns",
    logout: "Ausloggen",
    logoutSuccess: "Ausgeloggt",
    privacy: "Datenschutzrichtlinie",
    service: "Nutzungsbedingungen",
    title: "Einstellungen",
  },
  shop: {
    emptyTip: "Shop im Aufbau, bleibt dran.",
    record: "Tauschverlauf",
    title: "Tauschzentrum",
    bindRole: "Charakter verknüpfen",
    switchRole: "Charakter wechseln",
    tabs: {
      tasks: "Punktaufgaben",
      rewards: "Belohnungstausch",
    },
    taskInProgress: "In Bearbeitung",
    taskCompleted: "Abgeschlossen",
    goToComplete: "Quest",
    exchange: "Tauschen",
    exchanged: "Getauscht",
    exchangeConfirmTitle: "Tausch bestätigen?",
    currentCoins: "Aktuelle Punkte",
    costCoins: "Zu verbrauchende Punkte",
    receiveRole: "Empfangender Charakter",
    exchangeSuccess: "Tausch erfolgreich",
    exchangeFailed: "Tausch fehlgeschlagen",
  },
  exchangeRecord: {
    time: "Zeit",
    content: "Inhalt",
    points: "Punkte",
    empty: "Keine Tauschaufzeichnungen",
  },
  tabBar: {
    home: "Startseite",
    notice: "Nachricht",
    profile: "Mein",
  },
  time: {
    hoursAgo: "Vor {hours} Stunden",
    minutesAgo: "Vor {minutes} Minuten",
  },
};
